
import AboutUs1 from "./AboutUs/AboutUs1";
import Destinations1 from "./Destinations/Destination1";
import Destinations2 from "./Destinations/Destination2";
import Destinations3 from "./Destinations/Destination3";
import FeaturedPackages1 from "./featured-packages/FeaturedPackages1";
import FeaturedPackages2 from "./featured-packages/FeaturedPackages2";
import TemplateFooter1 from "./Footer/TemplateFooter1";
import TemplateFooter2 from "./Footer/TemplateFooter2";
import TemplateFooter3 from "./Footer/TemplateFooter3";
import TemplateHeaderHybrid from "./Header/TemplateHeader-Hybrid";
import TemplateHeaderHybrid2 from "./Header/TemplateHeader-Hybrid2";

import TemplateHeader1 from "./Header/TemplateHeader1";
import TemplateHeader2 from "./Header/TemplateHeader2";
import TemplateHeader3 from "./Header/TemplateHeader3";
import TemplateHeroTabbedSearch from "./Hero/TemplateHero-TabbedSearch";
import TemplateHeroTabbedSearch2 from "./Hero/TemplateHero-TabbedSearch2";

import TemplateHero1 from "./Hero/TemplateHero1";
import TemplateHero2 from "./Hero/TemplateHero2";
import TemplateHero3 from "./Hero/TemplateHero3";
import Testimonials1 from "./Testimonals/Testimonials1";
import Testimonials2 from "./Testimonals/Testimonials2";
import TopBar1 from "./TopBars/TopBar1";
import TopBar2 from "./TopBars/TopBar2";

export const componentMap = {
  TopBar1: TopBar1,
  TopBar2: TopBar2,
  
  TemplateHeader1: TemplateHeader1,
  TemplateHeader2: TemplateHeader2,
  TemplateHeader3: TemplateHeader3,
  TemplateHeaderHybrid: TemplateHeaderHybrid,
  TemplateHeaderHybrid2: TemplateHeaderHybrid2,

  TemplateHero1: TemplateHero1,
  TemplateHero2: TemplateHero2,
  TemplateHero3: TemplateHero3,
  TemplateHeroTabbedSearch: TemplateHeroTabbedSearch,
  TemplateHeroTabbedSearch2: TemplateHeroTabbedSearch2,

  FeaturedPackages1: FeaturedPackages1,
  FeaturedPackages2: FeaturedPackages2,

  Destinations1 : Destinations1,
  Destinations2: Destinations2,
  Destinations3: Destinations3,


  Testimonials1: Testimonials1,
  Testimonials2: Testimonials2,
  
  AboutUs1: AboutUs1,

  TemplateFooter1: TemplateFooter1,
  TemplateFooter2: TemplateFooter2,
  TemplateFooter3: TemplateFooter3,

  // When you create HeaderB, you will add it here
};